import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import backRed from "../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";
import "./DepartmentForm.scss";

const DepartmentForm = ({ edit = false }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const { id } = useParams();
  const [fields, setFields] = useState({});
  const [checked, setChecked] = useState(true);
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);

  const onSubmit = (fields) => {
    let updatedFileds = {
      ...fields,
      department: fields?.department?.trim(),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}career-add-department/create`,
        updatedFileds,
      )
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const handleUpdateData = (fields) => {
    let item = {
      ...fields,
      department: fields.department,
    };
    fetch(
      `${process.env.REACT_APP_API_URL}career-add-department/update/${id}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      },
    ).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getDepartmentData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}career-add-department/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getDepartmentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadcrumbsList = useMemo(
    () => [
      { text: "Careers", link: "/careers" },
      {
        text: edit ? "Edit Department / Function" : "Add Department / Function",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/careerdepartment")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            edit ? handleUpdateData(fields) : onSubmit(fields);
          }}
          className="carr-dep-form p-1"
        >
          <div className="row car-dep-form">
            <div className="col-5">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Type Department / Function name <span className="star">*</span>
              </label>
              <input
                className="form-control w-75"
                type="text"
                name=""
                id="department"
                value={fields.department}
                onChange={(e) =>
                  setFields((prevState) => {
                    return { ...prevState, department: e.target.value };
                  })
                }
                placeholder="Type here..."
              />
              {errors.department && (
                <div className={`invalid-feedback d-block`}>
                  Please Enter department
                </div>
              )}
            </div>

            <div className="col-3">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Status <span className="star">*</span>
              </label>
              <div className="d-flex">
                <div className="form-check form-check-inline align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, status: "Active", active: true };
                      });
                    }}
                    value={true}
                    checked={fields.active === true ? "checked" : null}
                  />
                  <label htmlFor="option-1" className="text-dark ">
                    Active
                  </label>
                </div>
                <div className="form-check form-check-inline align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    value={false}
                    onChange={(e) => {
                      setFields((prevState) => {
                        return {
                          ...prevState,
                          status: "Inactive",
                          active: false,
                        };
                      });
                    }}
                    checked={fields.active === false ? "checked" : null}
                  />
                  <label htmlFor="option-2" className="text-dark">
                    Inactive
                  </label>
                </div>
              </div>
              {errors.status && (
                <div className={`invalid-feedback d-block`}>
                  Please select an Option
                </div>
              )}
            </div>
          </div>

          <div className="car-dep-form-button">
            <button type="submit" style={{ marginTop: "5%", border: "none" }}>
              SUBMIT
            </button>
          </div>
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/careerdepartment"}
          name="Career Department"
          post="posted"
        />
      )}
    </>
  );
};
export default DepartmentForm;
